module.exports = __webpack_public_path__ + "img/citi.61df937e.png";